import {
  Component,
  OnInit,
  ViewContainerRef,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
} from '@angular/core';
import { ModalDialogService } from 'ngx-modal-dialog';
import { Subject } from 'rxjs/Subject';
import { takeUntil } from 'rxjs/operators/takeUntil';

import { AlgConditionModalComponent } from '../../dialogs/alg-condition-modal/alg-condition-modal.component';
import {
  consensoVeloceConditionsText,
  conditionTextList,
} from '../../../models/contitions';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilsService } from '../../../services/utils.service';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { ApiService } from '../../../services/api.service';

@Component({
  selector: 'alg-agile-general-condition',
  templateUrl: './alg-agile-general-condition.component.html',
  styleUrls: ['./alg-agile-general-condition.component.scss'],
})
export class AlgAgileGeneralConditionComponent implements OnInit, OnDestroy {
  @Output() checkboxOutputConsents = new EventEmitter<boolean>();

  @Input() contractType: string;
  @Input() discountType: string;
  @Input() data: any;
  @Input() checkboxInput: Object = {};
  public contractForm: FormGroup;
  public policiesUrls: any = {};
  private opportunityCategoryNumber: number;
  private ngUnsubscribe = new Subject<void>();
  private contractTypeCTE: string;
  private contractTypeCGF: string;
  public consentsContent: any;
  public clauseContent: any;
  public supplyType = null;
  public placet = null;
  public isUnipol: boolean;
  public controlCheckboxesClause: boolean;
  public controlCheckboxesConsents: boolean;
  public cteLink: string;
  public cgfLink: string;

  public readAcceptances = {
    consents: false,
  };

  public readAcceptance = {
    consentsCondition: false,
  };

  constructor(private consensoSerivce: AlgConsensoService) {}

  ngOnInit() {
    // SUBSCRIBE: Save a local copy of policies urls
    this.consensoSerivce.policiesUrl$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((policies) => {
        this.policiesUrls = policies;
      });

    // SUBSCRIBE: Save a local copy of opportunity category number
    this.consensoSerivce.categoryNumber$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((opportunityCategoryNumber) => {
        this.opportunityCategoryNumber = opportunityCategoryNumber;
      });
    this.contractForm = new FormGroup({
      consentsCondition: new FormControl(
        this.readAcceptance.consentsCondition,
        {
          validators: [Validators.requiredTrue],
        }
      ),
    });

    this.contractForm.valueChanges.subscribe((data) => {
      this.readAcceptance.consentsCondition = data.consentsCondition;
    });

    this.clauseContent =
      consensoVeloceConditionsText.clause.get(this.opportunityCategoryNumber) ||
      consensoVeloceConditionsText.clause.get(0);

    const discountString =
      this.discountType === 'buono' ? 'BUONO12' : 'SCONTO12';
    this.convertContracTypeToString(this.contractType);
    this.cteLink = `https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/agile/122021_ALLB-CTE-CASAAGILE-${this.contractTypeCTE}-NA-${discountString}-ALG.pdf`;

    this.cgfLink = `https://s3.eu-central-1.amazonaws.com/documenti.lucegasecoop.it/agile/CGF/General+Conditions+${this.contractTypeCGF}+-+ALG.pdf`;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  changeCheckbox() {
    this.readAcceptance.consentsCondition =
      !this.readAcceptance.consentsCondition;
    this.controlCheckboxesConsents = !this.readAcceptance.consentsCondition;
    this.checkboxOutputConsents.emit(this.readAcceptance.consentsCondition);
  }

  convertContracTypeToString(contract: string) {
    switch (contract) {
      case 'mono-luce':
        this.contractTypeCTE = 'ee'.toUpperCase();
        this.contractTypeCGF = 'Mono+EE';
        break;
      case 'mono-gas':
        this.contractTypeCTE = 'gas'.toUpperCase();
        this.contractTypeCGF = 'Mono+Gas';
        break;
      case 'dual':
        this.contractTypeCTE = 'dual'.toUpperCase();
        this.contractTypeCGF = 'DUO';
        break;
      default:
        return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-agile-general-condition/alg-agile-general-condition.component.ts